module.exports = __webpack_public_path__ + "static/img/Dallin-Watene-Zelezniak.3ac0be9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dallin-Watene-Zelezniak.jpg
// module id = ffWo
// module chunks = 0